import { FunnelFlowConfig, quiz, screen } from 'funnel/src/app/flow/flow-config';

export const googleFunnelFlow: FunnelFlowConfig = {
  screens: [
    screen('intro'),

    quiz('gender'),

    quiz('format'),

    quiz('audioExperience'),

    quiz('usageFrequency'),

    quiz('frustrations'),

    quiz('goals'),

    quiz('goalInfo'),

    quiz('voicePreference'),

    quiz('time'),

    quiz('honest'),
    screen('customization'),

    quiz('demo1'),
    quiz('demo2'),
    quiz('demo3'),
    quiz('demo4'),

    quiz('audioCustomizationInfo'),

    quiz('amountInfo'),
    screen('ready'),
    screen('login'),
    screen('paywall'),
  ],
};
